import { Asset } from "./Asset";
import { Engine } from "@spi/Engine/Engine";

export class AssetLoader {
    private assets: Asset[];

    constructor() {
        this.assets = [];
    }

    public resolveAssets (engine: Engine): Promise<void[]> {
        return Promise.all(this.assets.map(asset => asset.resolveAsset(engine)));
    }

    public addAsset(asset: Asset) {
        this.assets.push(asset);
    }
}
